function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useContext, useEffect, useRef, useState, useMemo } from 'react';
import { useElementSize, useRefCallback } from '@bydesign-ui/hooks';
import { classnames, shallowEqual } from '@bydesign-ui/utils';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { Add, Down, Left, Right, Up } from '../../../common/icons';
import { Dropdown } from '../../../components/dropdown';
import { TabsContext } from './../hooks';
import { TabBarItem } from './TabBarItem';

var defaultRenderTabBar = function defaultRenderTabBar(props) {
  return props.tab;
};

var sizeTransitionTime = 240;
export function TabBars(props) {
  var hideAdd = props.hideAdd,
      type = props.type,
      tabPosition = props.tabPosition,
      extraTabBar = props.extraTabBar,
      _props$renderTabBar = props.renderTabBar,
      renderTabBar = _props$renderTabBar === void 0 ? defaultRenderTabBar : _props$renderTabBar,
      children = props.children,
      className = props.className,
      onTabClick = props.onTabClick,
      size = props.size;
  var showAdd = !hideAdd && type === 'editable';
  var barList = [];
  var collapseBarList = [];
  var tabs = useContext(TabsContext);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showPrev = _useState2[0],
      setShowPrev = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showNext = _useState4[0],
      setShowNext = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isSizeChange = _useState6[0],
      setSizeChange = _useState6[1];

  var _useState7 = useState(React.Children.count(children)),
      _useState8 = _slicedToArray(_useState7, 2),
      collapseIndex = _useState8[0],
      setCollapseIndex = _useState8[1];

  var tabsBarRef = useRef(null);
  var wrapperRef = useRef(null);
  var innerRef = useRef(null);
  var containerRef = useRef(null);
  var collapseActive = useRef(false);
  var activeRef = useMemo(function () {
    if (tabs.active != null) {
      var itemInfo = tabs.items.get(tabs.active);
      return itemInfo === null || itemInfo === void 0 ? void 0 : itemInfo.tabBarRef;
    }
  }, [tabs.active]);

  function W1() {
    var wrapper = wrapperRef.current;
    if (!wrapper) return 0;
    return wrapper.scrollWidth - wrapper.scrollLeft - wrapper.offsetWidth;
  }

  function W2(item) {
    var wrapper = wrapperRef.current;
    if (!wrapper) return 0;
    return wrapper.scrollWidth - item.offsetLeft - item.offsetWidth;
  }

  useEffect(function () {
    setSizeChange(true);
  }, [size]);
  useEffect(function () {
    var _a, _b, _c;

    function setConatinerSize() {
      var container = containerRef.current;
      var inner = innerRef.current;

      if (container && inner) {
        container.style.width = "".concat(inner.scrollWidth, "px");
      }
    }

    (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('mouseover', setConatinerSize);

    function removeContainerSize() {
      var _a;

      var tabIds = Array.from(tabs.items.keys());
      if (!tabIds.length) return;
      var lastTabId = tabIds[tabIds.length - 1];
      var lastTab = tabs.items.get(lastTabId);
      if (!lastTab) return;
      var lastTabBar = (_a = lastTab.tabBarRef) === null || _a === void 0 ? void 0 : _a.current;
      var wrapper = wrapperRef.current;

      if (lastTabBar && wrapper) {
        var w1 = W1();
        var w2 = W2(lastTabBar);

        if (w2 > w1) {
          var scrollPosition = wrapper.scrollLeft - (w2 - w1);
          wrapper.scrollTo(scrollPosition, 0);
        }
      }

      setTimeout(function () {
        if (containerRef.current) {
          containerRef.current.style.width = '';
        }

        checkShowPrevNext();
      }, 300);
    }

    (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener('mouseleave', removeContainerSize);

    function checkShowPrevNext() {
      var wrapper = wrapperRef.current;

      if (wrapper) {
        requestAnimationFrame(function () {
          setShowPrev(wrapper.scrollLeft > 0);
          setShowNext(W1() > 28);
        });
      }
    }

    (_c = wrapperRef.current) === null || _c === void 0 ? void 0 : _c.addEventListener('scroll', checkShowPrevNext);
    checkShowPrevNext();
    return function () {
      var _a, _b, _c;

      (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('mouseover', setConatinerSize);
      (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('mouseleave', removeContainerSize);
      (_c = wrapperRef.current) === null || _c === void 0 ? void 0 : _c.removeEventListener('scroll', checkShowPrevNext);
    };
  }, []);
  useEffect(function () {
    var active = activeRef === null || activeRef === void 0 ? void 0 : activeRef.current;
    var wrapper = wrapperRef.current;

    if (active && wrapper) {
      if (active.offsetLeft < wrapper.scrollLeft) {
        wrapper.scrollTo(active.offsetLeft, 0);
        return;
      } else if (W2(active) < W1()) {
        var scrollPosition = active.offsetLeft + active.offsetWidth - wrapper.offsetWidth;
        wrapper.scrollTo(scrollPosition, 0);
      }
    }
  }, [tabs.active]);
  var isVertical = tabPosition === 'left' || tabPosition === 'right';
  var PrevIcon = !isVertical ? React.createElement(Left, null) : React.createElement(Up, null);
  var NextIcon = !isVertical ? React.createElement(Right, null) : React.createElement(Down, null);

  var shouldChange = function shouldChange(clickId) {
    return new Promise(function (resolve) {
      var beforeActiveChange = tabs.shouldChangeActive;

      if (!beforeActiveChange) {
        return resolve(true);
      }

      var result = beforeActiveChange(clickId);

      if (result != null && _typeof(result) === 'object' && typeof result.then === 'function') {
        return resolve(result);
      }

      return resolve(!!result);
    });
  };

  var onBarItemClick = useRefCallback(function (id) {
    shouldChange(id).then(function (res) {
      if (!res) return;
      tabs.setActive(id);
    }).catch(function (err) {
      return console.warn(err);
    });
    onTabClick && onTabClick(id);
  });

  var handleClickArrow = function handleClickArrow(direction) {
    var _a, _b;

    var wrapper = wrapperRef.current;
    if (!wrapper) return;

    if (direction === 'prev') {
      var targetTabBar = Array.from(tabs.items.values()).find(function (tabBar) {
        var _a;

        var item = (_a = tabBar.tabBarRef) === null || _a === void 0 ? void 0 : _a.current;
        if (!item) return false;
        return item.offsetLeft < wrapper.scrollLeft && item.offsetLeft + item.offsetWidth > wrapper.scrollLeft;
      });
      var item = (_a = targetTabBar === null || targetTabBar === void 0 ? void 0 : targetTabBar.tabBarRef) === null || _a === void 0 ? void 0 : _a.current;
      if (!item) return;
      var scrollPosition = wrapper.scrollLeft - (W2(item) - W1());
      wrapper.scrollTo(scrollPosition, 0);
    }

    if (direction === 'next') {
      var w1 = W1();

      var _targetTabBar = Array.from(tabs.items.values()).find(function (tabBar) {
        var _a;

        var item = (_a = tabBar.tabBarRef) === null || _a === void 0 ? void 0 : _a.current;
        if (!item) return false;
        var w2 = W2(item);
        return w2 < w1 && w2 + item.offsetWidth > w1;
      });

      var _item = (_b = _targetTabBar === null || _targetTabBar === void 0 ? void 0 : _targetTabBar.tabBarRef) === null || _b === void 0 ? void 0 : _b.current;

      if (!_item) return;
      wrapper.scrollTo(_item.offsetLeft, 0);
    }
  };

  function handleItemUnregistered(id) {
    var _a, _b;

    var wrapper = wrapperRef.current;
    if (!wrapper) return;
    if (wrapper.scrollLeft === 0) return;

    if (!tabs.items.has(id)) {
      console.error("Tab id ".concat(id, " not found."));
      return;
    }

    var tabIds = Array.from(tabs.items.keys());
    var tabIndex = tabIds.findIndex(function (tabId) {
      return tabId === id;
    });
    var isLastTab = tabIndex === tabIds.length - 1;
    if (!isLastTab) return;
    var lastTab = tabs.items.get(id);
    var last = (_a = lastTab === null || lastTab === void 0 ? void 0 : lastTab.tabBarRef) === null || _a === void 0 ? void 0 : _a.current;
    var prevTab = tabs.items.get(tabIds[tabIndex - 1]);
    var prev = (_b = prevTab === null || prevTab === void 0 ? void 0 : prevTab.tabBarRef) === null || _b === void 0 ? void 0 : _b.current;

    if (last && prev) {
      var scrollDistance = last.offsetLeft + last.offsetWidth - (prev.offsetLeft + prev.offsetWidth);
      var scrollPosition = wrapper.scrollLeft - scrollDistance + 1;
      wrapper.scrollTo(scrollPosition, 0);
    }
  }

  function checkCollapse() {
    if (type !== 'collapse') return;
    var wrapper = wrapperRef.current;
    if (!wrapper) return;
    var w1 = W1();

    if (wrapper.scrollLeft > 0 || w1 > 1) {
      var _collapseIndex = Array.from(tabs.items.values()).findIndex(function (tabBar) {
        var _a;

        var item = (_a = tabBar.tabBarRef) === null || _a === void 0 ? void 0 : _a.current;
        if (!item) return false;
        var w2 = W2(item);
        return w2 < w1 && w2 + item.offsetWidth > w1;
      });

      if (_collapseIndex > -1) {
        setCollapseIndex(_collapseIndex);
      }
    }
  }

  useElementSize(tabsBarRef, function () {
    return type === 'collapse';
  }, function (size, oldSize) {
    if (oldSize.width > size.width) {
      checkCollapse();
    } else {
      setCollapseIndex(React.Children.count(children));
    }
  });
  useEffect(function () {
    checkCollapse();
  }, [collapseIndex]);
  var itemsCls = usePrefixCls('tab-bar-items');
  var itemsInnerCls = usePrefixCls('tab-bar-items-inner');
  var itemsContainerCls = usePrefixCls('tab-bar-items-container');
  var prevCls = usePrefixCls('tab-bar-prev');
  var nextCls = usePrefixCls('tab-bar-next');
  var tabExtraCls = usePrefixCls('tab-bar-extra');
  var tabExtraContentCls = usePrefixCls('tab-bar-extra-content');
  var tabAddCls = usePrefixCls('tab-bar-add');
  var lastIsActive = false;
  React.Children.forEach(children, function (child, index) {
    var _child$props = child.props,
        _child$props$id = _child$props.id,
        id = _child$props$id === void 0 ? "".concat(index) : _child$props$id,
        _child$props$disabled = _child$props.disabled,
        disabled = _child$props$disabled === void 0 ? false : _child$props$disabled,
        _child$props$closable = _child$props.closable,
        closable = _child$props$closable === void 0 ? true : _child$props$closable;
    var isActive = tabs.active === id;
    var label = renderTabBar(child.props);
    var collapsed = type === 'collapse' && index >= collapseIndex;
    var Bar = React.createElement(TabBarItem, {
      id: id,
      index: index,
      collapsed: collapsed,
      disabled: disabled,
      closable: closable && type === 'editable',
      active: isActive,
      lastIsActive: lastIsActive,
      onClick: onBarItemClick,
      handleClose: function handleClose(id) {
        return tabs.closeItem(id);
      },
      onUnregistered: handleItemUnregistered,
      label: label,
      key: id
    });

    if (collapsed) {
      if (index === collapseIndex) {
        collapseActive.current = false;
      }

      if (!collapseActive.current && isActive) {
        collapseActive.current = true;
      }

      collapseBarList.push(Bar);
    } else {
      barList.push(Bar);
    }

    lastIsActive = isActive;
  });
  var localeMore = useLocale('tabs.more');
  var tabCls = classnames(usePrefixCls('tab-bar'), className);
  var collapseCls = usePrefixCls('tab-bar-collapse', {
    active: collapseActive.current
  });
  var animatedLine = useAnimatedTabBarLine(isVertical, tabs.items, tabs === null || tabs === void 0 ? void 0 : tabs.active, isSizeChange, setSizeChange);
  return React.createElement("div", {
    className: tabCls,
    ref: tabsBarRef
  }, showPrev && type !== 'collapse' && React.createElement("div", {
    className: prevCls,
    onClick: function onClick() {
      return handleClickArrow('prev');
    }
  }, PrevIcon), React.createElement("div", {
    className: itemsCls,
    ref: wrapperRef
  }, React.createElement("div", {
    className: itemsContainerCls,
    ref: containerRef
  }, React.createElement("div", {
    className: itemsInnerCls,
    ref: innerRef
  }, barList, animatedLine))), showNext && type !== 'collapse' && React.createElement("div", {
    className: nextCls,
    onClick: function onClick() {
      return handleClickArrow('next');
    }
  }, NextIcon), React.createElement("div", {
    className: tabExtraCls
  }, type === 'collapse' && collapseBarList.length > 0 && React.createElement("div", {
    className: collapseCls
  }, React.createElement(Dropdown.Link, {
    trigger: "hover",
    placement: "bottom-end",
    menu: React.createElement(Dropdown.Menu, {
      onClick: function onClick(id) {
        return onBarItemClick(id);
      }
    }, collapseBarList)
  }, localeMore)), showAdd && React.createElement("div", {
    className: tabAddCls,
    onClick: function onClick() {
      return tabs.addItem();
    }
  }, React.createElement(Add, null)), extraTabBar && React.createElement("div", {
    className: tabExtraContentCls
  }, extraTabBar)));
}

function useAnimatedTabBarLine(isVertical, items, active, isSizeChange, setSizeChange) {
  var lineRef = useRef(null);
  var prevLineStyleRef = useRef({
    width: 0,
    height: 0,
    left: 0,
    top: 0
  });
  var itemsInnerLineCls = usePrefixCls('tab-bar-items-inner-line');
  useEffect(function () {
    if (isSizeChange) {
      setTimeout(function () {
        setNewStyle();
        setSizeChange(false);
      }, sizeTransitionTime);
    } else {
      setNewStyle();
    }
  });

  var setNewStyle = function setNewStyle() {
    if (!active) return;
    var itemInfo = items.get(active);
    var activeRef = itemInfo === null || itemInfo === void 0 ? void 0 : itemInfo.tabBarRef;
    var lineElement = lineRef.current;

    if (!lineElement || !(activeRef === null || activeRef === void 0 ? void 0 : activeRef.current)) {
      return;
    }

    var nextStyle = {
      top: activeRef.current.offsetTop,
      left: activeRef.current.offsetLeft,
      width: activeRef.current.offsetWidth,
      height: activeRef.current.offsetHeight
    };

    if (shallowEqual(prevLineStyleRef.current, nextStyle)) {
      return;
    }

    prevLineStyleRef.current = nextStyle;

    if (isVertical) {
      lineElement.style.removeProperty('left');
      lineElement.style.removeProperty('width');
      lineElement.style.setProperty('top', "".concat(nextStyle.top, "px"));
      lineElement.style.setProperty('height', "".concat(nextStyle.height, "px"));
    } else {
      lineElement.style.removeProperty('top');
      lineElement.style.removeProperty('height');
      lineElement.style.setProperty('left', "".concat(nextStyle.left, "px"));
      lineElement.style.setProperty('width', "".concat(nextStyle.width, "px"));
    }
  };

  return React.createElement("div", {
    className: itemsInnerLineCls,
    key: "tab-bar-items-inner-line",
    ref: lineRef
  });
}